<script>
  import Contact from './Contact.svelte';
  import { classes } from '../helpers';

  const long = new Intl.DateTimeFormat("en-US", {
    year:"numeric",
    month:"long",
    weekday:"long",
    day:"numeric",
    hour:"numeric",
    minute:"numeric",
  }).format;

  const med = new Intl.DateTimeFormat("en-US", {
    year:undefined,
    month:"short",
    weekday:"short",
    day:"numeric",
    hour:"numeric",
    minute:"numeric",
  });

  const short = new Intl.DateTimeFormat("en-US", {
    year:undefined,
    month:"short",
    day:"numeric",
    hour:"numeric",
    minute:"numeric",
  });

  const timeYear = ((11 * 30) + 6) * 24 * 60 * 60 * 1000;
  const timeWeek = 6 * 24 * 60 * 60 * 1000;

  //const format = short.format;
  function format(date) {
    var now = new Date();

    const withinAWeek = (now - timeWeek) < date || (now + timeWeek) > date;
    const withinAYear = (now - timeYear) < date || (now + timeYear) > date;

    return date.toLocaleString("en-US", {
      year: !withinAYear ? "numeric" : undefined,
      month: !withinAWeek ? "short" : undefined,
      weekday: withinAWeek ? "short" : undefined,
      day: !withinAWeek ? "numeric" : undefined,
      hour: "numeric",
      minute: "numeric",
    }).replace(/,/g, "");
  }

  let klass = [];
  export { klass as class };
  export let utc;
  export let local = null;
  export let title = null;
  export let user = null;

  function getDate(t) {
    const result = new Date(t);
    return isNaN(result.getTime()) ? null : result;
  }

  $: time = getDate(local || utc);
</script>

<time class={classes(klass)} datetime={utc}>
  <slot name='title'>
    {#if title}<dfn>{title}</dfn>{/if}
  </slot>
  <slot {time}>
    {#if time}<abbr title="{long(time)}">{format(time)}</abbr>{/if}
  </slot>
  <slot name='user'>
    {#if user}<Contact item={user} />{/if}
  </slot>
</time>
